module.exports = __webpack_public_path__ + "static/media/drop.7b8b2af5.svg";